import React from "react";
import { BsFillMoonStarsFill } from "react-icons/bs";
const Nav = ({ darkMode, setDarkMode }) => {
  return (
    <>
      <nav className="flex justify-between py-6 mb-12 dark:bg-[#191716]">
        <h1 className="text-3xl items-center font-bold dark:text-[#E0E2DB] ">
          Faical Bounedjar
        </h1>
        <ul className="md:flex items-center mr-5 w-38  ">
          {/* dark mode */}
          <li
            onClick={() => {
              setDarkMode(!darkMode);
              localStorage.setItem("darkMode", JSON.stringify(!darkMode));
            }}
            className="bg-[#511730] hover:bg-[#7f3253] hover:scale-125 duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] ml-20 md:ml-0  p-1 lg:mb-0 md:mb-0 mb-8 w-16 rounded-full"
          >
            <BsFillMoonStarsFill
              className=" text-white  cursor-pointer flex px-auto mx-auto  "
              size={25}
            />
          </li>
          {/* resumer */}
          <li>
            <a
              className="cursor-pointer ml-5 bg-[#511730] hover:bg-[#7f3253] dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] flex justify-center p-4 py-2 rounded-md text-white"
              href="https://drive.google.com/file/d/14X28c6pBBZHJU2q1qBC7I8o1V335xXgP"
              target="_blank"
              rel="noreferrer"
            >
              download my resume
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Nav;
